import React, { useState } from 'react'
import {
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Button,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { LoadingSpinner, MEModal } from '@CommonComponents'
import { client, toTitleCase } from '@Utils'
import { useStateValue } from '../state'
import { TemplateRow } from './TemplateRow'

export const TemplateTable = ({ tempType, templates }) => {
  let [currentState, dispatch] = useStateValue()
  let [modalOpen, toggleModal] = useState(false)
  let [acmtName, setAcmtName] = useState('')
  let [designId, setDesignId] = useState('')
  let [isLoading, setIsLoading] = useState(false)

  const handleSave = async evt => {
    evt.preventDefault()
    setIsLoading(true)
    let url = '/account/admin_achievements.create_template/'

    let postData = {
      type: tempType,
      name: acmtName,
    }
    let designKey = `${tempType}DesignId`
    postData[designKey] = designId
    try {
      let resp = await client.post(url, postData)
      let stateAcmts =
        tempType === 'certificate'
          ? currentState.certificates
          : currentState.badges
      let dispatchType =
        tempType === 'certificate' ? 'updateCerts' : 'updateBadges'
      stateAcmts.push(resp.data.acmtTemplate)
      let newAcmts = stateAcmts
      dispatch({
        type: dispatchType,
        payload: newAcmts,
      })
    } catch (err) {
      console.error(err)
      let errMsg = err.response.data.msg
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
    }
    setIsLoading(false)
    toggleModal(false)
    setAcmtName('')
    setDesignId('')
  }

  const handleCloseModal = () => {
    setAcmtName('')
    setDesignId('')
    toggleModal(false)
  }

  return (
    <div className="card-myed">
      <div className="d-flex justify-content-between">
        <h2 className="my-0 w-50">{toTitleCase(tempType) + 's'}</h2>
        <button
          onClick={() => toggleModal(true)}
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
        >
          <i className="far fa-plus mr-3" />
          Add
        </button>
      </div>
      {templates.length > 0 ? (
        templates.map((acmt, i) => (
          <TemplateRow key={i} tempType={tempType} template={acmt} />
        ))
      ) : (
        <h4>{`No ${tempType} templates have been created`}</h4>
      )}
      <MEModal
        show={modalOpen}
        close={handleCloseModal}
        title={`Create ${toTitleCase(tempType)} Template`}
      >
        <Form>
          <FormGroup>
            <ControlLabel className="mb-0">{`${toTitleCase(
              tempType
            )} Name`}</ControlLabel>
            <FormControl
              type="text"
              onChange={e => setAcmtName(e.target.value)}
              value={acmtName}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel className="mb-0">Design ID</ControlLabel>
            <FormControl
              componentClass="select"
              value={designId}
              onChange={e => setDesignId(e.target.value)}
            >
              <option value="">Select Design</option>
              {currentState[`${tempType}Designs`] &&
                currentState[`${tempType}Designs`].map((design, i) => (
                  <option key={i} value={design.id}>
                    {`${design.name} - ${design.id}`}
                  </option>
                ))}
            </FormControl>
          </FormGroup>
          <div className="d-flex justify-content-center">
            <span className="mt-3">
              <Button
                className="btn-myed btn-default-myed mr-3"
                type="button"
                bsStyle="default"
                onClick={handleCloseModal}
                disabled={isLoading}
              >
                <i className="far fa-times mr-2" />
                Cancel
              </Button>
              <Button
                className="btn-myed btn-primary-myed"
                type="button"
                bsStyle="primary"
                onClick={e => handleSave(e)}
                disabled={isLoading || !(acmtName && designId)}
              >
                <div className="d-flex align-items-center">
                  {isLoading ? (
                    <LoadingSpinner
                      className="align-self-center"
                      style={{
                        fontSize: '15px',
                        color: 'white',
                        marginRight: '4px',
                      }}
                    />
                  ) : (
                    <i className="far fa-cloud-upload mr-2" />
                  )}
                  <span>{isLoading ? 'Creating' : 'Create'}</span>
                </div>
              </Button>
            </span>
          </div>
        </Form>
      </MEModal>
    </div>
  )
}
